import { createContext, type PropsWithChildren, type ReactNode, useState } from 'react';

interface DrawerContextType {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (open: boolean) => void;
  drawerChild: ReactNode;
  setDrawerChild: (child: ReactNode) => void;
}

const DrawerContext = createContext<DrawerContextType | null>(null);

const DrawerProvider = ({ children }: PropsWithChildren) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerChild, setDrawerChild] = useState<ReactNode | null>(null);

  const handleSetDrawerOpen = (open: boolean) => {
    setIsDrawerOpen(open);
    if (!open) {
      setTimeout(() => setDrawerChild(null), 300); // Espera a que termine la animación
    }
  };

  const value: DrawerContextType = {
    isDrawerOpen,
    setIsDrawerOpen: handleSetDrawerOpen,
    drawerChild,
    setDrawerChild
  };

  return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
};

export { DrawerContext, DrawerProvider };
